import './lib/router';
import './lib/fos_js_routes';

const Router = window.fos && window.fos.Router;

module.exports = Router;


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/util/router.js